import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { breakpoints } from "../styles";

interface Output {
    [index: string]: number[];
}

export const SearchEcg = (props: {
    sampleSize: number;
    output: Output;
    setSelectionFilter: Function;
    handleSelectPatient: Function;
}) => {
    const CATEGORIES = 7;
    const LEADS = 12;
    const THRESHOLD = 0.4;
    const symptomMap = [
        [1, 7, 11], // 1daVB
        [6, 11], // RBBB
        [6, 11], // LBBB
        [1], // SB
        [1, 2], // AF
        [1], // ST
        [], // Normal
    ];
    const [selections, setSelections] = useState<boolean[]>(
        new Array(CATEGORIES).fill(true)
    );

    const labels = [
        "1st degree AV block",
        "Right bundle branch block",
        "Left bundle branch block",
        "Sinus bradycardia",
        "Atrial fibrillation",
        "Sinus tachycardia",
        "Normal",
    ];

    const handleCheckboxChange = (label: number) => {
        selections[label] = !selections[label];
        let samplesToDisplay = [];
        for (let i = 0; i < props.sampleSize; i++) {
            for (let j = 0; j < CATEGORIES; j++) {
                if (props.output[String(i)][j] >= THRESHOLD && selections[j]) {
                    samplesToDisplay.push(i);
                    break;
                }
            }
        }
        if (samplesToDisplay.length > 0) {
            props.handleSelectPatient(String(samplesToDisplay[0]));
        }
        props.setSelectionFilter(samplesToDisplay);
    };

    return (
        <div>
            <div className="field">
                <label className="label has-text-white">
                    Filter Samples by Condition
                </label>
                <Control className="control">
                    {selections.map((isChecked, index) => {
                        return (
                            <div>
                                <label className="checkbox">
                                    <FilterLabel key={labels[index]}>
                                        <input
                                            value={index}
                                            type="checkbox"
                                            defaultChecked={isChecked}
                                            onChange={(event) =>
                                                handleCheckboxChange(
                                                    parseInt(event.target.value)
                                                )
                                            }
                                        />
                                        {labels[index]}
                                    </FilterLabel>
                                </label>
                            </div>
                        );
                    })}
                </Control>
            </div>
        </div>
    );
};

const FilterLabel = styled.table`
    color: white;
    &:hover {
        color: PaleTurquoise;
    }
`;

const Control = styled.div`
    @media ${breakpoints.md} {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
    }
`;
